import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { pageAreaHandlers, pageAreaInitialState, pageAreaReducer } from '../reducers/PageAreaReducer';
import { FrameworkContext } from './FrameworkContent';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { usePageAreaData } from './useHelpers/usePageAreaData';
import { useRenders } from './useHelpers/useRenders';
import { usePageArea } from './useHelpers/usePageArea';
import { useProfileItems } from './useHelpers/useProfileItems';

export const PageAreaContext = createContext();

const PageAreaProvider = (props) => {

  const { getPageItems } = usePageArea()
  const { profileItems } = useProfileItems()

  useRenders('PageAreaProvider', true, true)

  const init_state = {}
  const [pageArea_state, pageData_dispatch] = useReducer(pageAreaReducer, pageAreaInitialState(init_state));

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { page_state, paps_state } = states ?? {}
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { pathViews, viewKey, view, pathName } = paps_state ?? {}
  const { trueView, layout: layout_page, desktopLayout: desktopLayout_page } = aps_page ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  const layout = desktopMode && desktopLayout_page ? desktopLayout_page : layout_page
  const { pageIcons: uiSelectedIcons, selectedItems: uiSelectedItems, fixFirstViewItem, gridTemplateRows } = layout ?? {}

  const { pageItemsActive } = useMemo(() => {
    return getPageItems()
  }, [
    pathViews,
    view,
    viewKey,
    trueView,
    desktopMode,
    aps_page,
    pathName
  ])

  const { pageData } = usePageAreaData()

  const pageArea_handlers = useMemo(
    () => pageAreaHandlers(pageData_dispatch),
    [pageData_dispatch]
  );

  useEffect(() => {
    const _prps = {
      fixFirstViewItem,
      gridTemplateRows,
      isAppUserPage: appUserSessionKey === viewKey,
      pageIcons: uiSelectedIcons,
      pageItemsActive,
      pageViewItemKeys: pageItemsActive ? Object.keys(pageItemsActive) : [],
      profileItems,
      selectedItems: uiSelectedItems,
      view
    }
    pageArea_handlers.handleInit_pageArea(_prps)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pageItemsActive]);

  useEffect(() => {
    pageArea_handlers.handleAmmend_pageData(pageData)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pageData]);

  return <PageAreaContext.Provider value={{ pageArea_state, pageArea_handlers }}>
    {props.children}
  </PageAreaContext.Provider>
};

export default PageAreaProvider